import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import AddIcon from '@mui/icons-material/Add';
import { PROJECT_STEP_PRIORITY_TYPE_ENUM } from 'enums';
import { GridRowModes, GridSlotProps, GridToolbarContainer } from '@mui/x-data-grid-premium';

const EditToolbarProducts = (props: GridSlotProps['toolbar'] & { showButton?: boolean }) => {
  const { setRows, setRowModesModel, showButton = true } = props;

  const handleClick = () => {
    const id = crypto.randomUUID();

    setRows((oldRows) => [
      ...oldRows,
      {
        id,
        projectId: '',
        environmentTypeId: null,
        liveDate: null,
        priority: PROJECT_STEP_PRIORITY_TYPE_ENUM.NON_URGENT,
        isOnHold: false,
        onHoldTotalDays: 0,
        relatedContactId: null,
        alternativeRelatedContactId: null,
        notes: '',
        isNew: true,
      },
    ]);

    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    }));
  };

  if (!showButton) return <></>;

  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
        <FormattedMessage id="project.table.addRow" defaultMessage="Satır Ekle" />
      </Button>
    </GridToolbarContainer>
  );
};

export default EditToolbarProducts;
